import { call, put, takeLatest, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  fetchRestaurantRequest,
  fetchRestaurantSuccess,
  fetchRestaurantFailure,
} from '../slices/restaurantSlice';
import type { RestaurantData } from '../slices/restaurantSlice';
import { ENDPOINTS } from '../../api/endPoints';


function* fetchRestaurantSaga(): Generator<any, void, any> {
  try {
    const restaurantId = yield select((state) => state.clover.restaurantId);
    
    const response = yield call(axios.get, ENDPOINTS.restaurantView, {
      headers: {
        'restaurantId': restaurantId
      }
    });

    if (response.data && response.data.length > 0) {
      const restaurantData: RestaurantData = response.data[0];
      yield put(fetchRestaurantSuccess(restaurantData));
    } else {
      yield put(fetchRestaurantFailure('No restaurant data found'));
    }
  } catch (error: any) {
    yield put(
      fetchRestaurantFailure(
        error.response?.data?.message || error.message || 'Failed to fetch restaurant data'
      )
    );
  }
}

export function* restaurantSaga() {
  yield takeLatest(fetchRestaurantRequest.type, fetchRestaurantSaga);
}
